import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from "react";
import ReactECharts from "echarts-for-react";
import ScoreIcon from './ScoreIcon'
import { helpers } from '../services/helpers';

const AveragesChart = forwardRef(function AveragesChart(props, ref) {
  const {
    getColorMapping: getColorMapping
  } = props;
  const chartRef = useRef(null);
  const [option, setOption] = useState({});
  const [activityLevel, setActivityLevel] = useState(0);
  const diary = useRef(null)

  const buildOption = (ctx = {}) => {
    if (!diary.current?.entries?.length) return {};
    const colorMap = ctx.colorMap || getColorMapping(diary.current.attributes);
    const data = diary.current.attributes.map(attribute => {
      return {
        name: attribute.name,
        value: parseFloat(
          diary.current.entries
            .filter(entry =>
              entry.attributes.find(innerAttribute =>
                innerAttribute.id === attribute.id
              )
            )
            .reduce(
              (sum, entry) =>
                sum + entry.attributes.find(
                  innerAttribute =>
                    innerAttribute.id === attribute.id
                ).value,
              0
            ) / diary.current.entries.length
        ).toFixed(1),
        itemStyle: {
          color: colorMap.get(attribute.name)
        }
      }
    })
    return {
      xAxis: {
        type: 'category',
        data: data.map(item => item.name),
        axisLabel: { rotate: 30 }
      },
      yAxis: {
        type: 'value',
        min: 0,
        max: 10,
      },
      series: [
        {
          type: 'bar',
          data: data.map(item => ({
            value: item.value,
            itemStyle: { color: colorMap.get(item.name) }
          }))
        }
      ],
      tooltip: {
        trigger: 'axis',
        formatter: (params) => {
          const p = params[0];
          return `${p.name}: ${p.value}`;
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        top: '5%',
        containLabel: true
      },
    }
  }

  const getEntriesMessage = () => {
    const entries = diary?.current?.entries || [];
    const count = entries.length;
    if (count === 0) return "No entries yet.";
    const sorted = entries
      .map(e => new Date(e.createdAt))
      .sort((a, b) => a - b);
    const first = sorted[0];
    const last = sorted[sorted.length - 1];
    const diffDays = Math.round((last - first) / (1000 * 60 * 60 * 24)) || 0;

    return `${count} entries over ${diffDays} day${diffDays === 1 ? "" : "s"}.`;
  }

  useImperativeHandle(ref, () => ({
    update: (newDiary, ctx = {}) => {
      diary.current = newDiary
      const newOption = buildOption(ctx);
      if (Object.keys(newOption).length) setOption(newOption);
      setActivityLevel(
        parseFloat(
          diary.current.entries.filter(entry => entry.activityLevel || entry.activityLevel === 0)
            .reduce(
              (sum, entry) => sum + entry.activityLevel,
              0,
            )
          /
          diary.current.entries.filter(entry => entry.activityLevel || entry.activityLevel === 0).length
        ).toFixed(1)
      )
    },
    getEChartsInstance: () => chartRef.current?.getEchartsInstance?.()
  }), [])

  return (
    <>
      <div className="review-card" style={{ marginBottom: '1rem', overflow: 'hidden' }}>
        <h3 style={{ textAlign: 'center' }}>Average Pain</h3>
        {/* TODO: THESE SHOULD BE COMPONENTS */}
        <div style={{ width: "100%", position: 'relative' }}>
          <div style={{ width: "100%", height: "220px", overflow: 'hidden' }}>
            <ReactECharts
              ref={chartRef}
              option={option || {}}
              style={{ height: "100%" }}
            />
          </div>
        </div>
        <div style={{ textAlign: "center", color: "#6c757d", fontSize: "0.9rem" }}>{getEntriesMessage()}</div>
      </div>
      <div className="review-card" style={{ marginBottom: '1rem', overflow: 'hidden' }}>
        <div className="form-content pain-entry" style={{ padding: "0.5rem 0" }}>
          <h3 style={{ textAlign: 'center', paddingBottom: "0.5rem" }}>Average Activity</h3>
          <div>
            <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
              <div style={{ textAlign: "center" }}>
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    width: "6rem",
                    height: "6rem",
                    borderRadius: "50%",
                    color: "white",
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                    boxShadow: "0 10px 15px rgba(0,0,0,0.1)",
                    transition: "all 0.3s ease",
                    backgroundColor: helpers.getColorForScore(activityLevel)
                  }}
                >
                  <div style={{
                    fontSize: "2rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <ScoreIcon score={activityLevel} getIconForScore={helpers.getActivityIconForScore} />
                  </div>
                  <div> {activityLevel}</div>
                </div>
                <div style={{ marginTop: "0.75rem" }}>
                  <span
                    style={{
                      fontSize: "1.125rem",
                      fontWeight: 500,
                      transition: "color 0.3s ease",
                      color: helpers.getColorForScore(activityLevel)
                    }}
                  >
                    {helpers.getDescriptionForScore(activityLevel)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ textAlign: "center", color: "#6c757d", fontSize: "0.9rem" }}>{getEntriesMessage()}</div>
      </div>
    </>
  );
});

export default AveragesChart;